import React from "react";

import TreeNode from "./TreeNode";
import { sortBy } from "lodash";
import { useSelector } from "react-redux";
import Spinner from '../../components/Spinner/index';


const Tree = (props) => {

  const sortNodes = (nodes) => sortBy(nodes, [
    childNode => {  // 1ª test numbers
      const match = childNode.name.match(/^\d+/); // see if begin with numbers
      return match ? match[0].padStart(10,'0') : ""; // if so, add zeros to compare, if not, return ""
    },
    node => node.name.toLowerCase(), // 2ª test: names
  ], ['asc', 'asc'])

  const getRootNodes = () => {
    const nodes =  props.nodes.filter(node => node.isRoot === true);
    const sortedNodes = sortNodes(nodes);
    return sortedNodes;
  };

  const loading = useSelector(state => state.places.loading);

  const getChildNodes = node => {
    const childNodes = props.nodes.filter(nodes => nodes.parent === node._id);
    const sortedChildNodes = sortNodes(childNodes);
    return sortedChildNodes;
  };

  return (
    <>
      <div style={{position: 'relative', opacity: loading ? 0.5 : 1}}>
        {loading &&  <Spinner overlay />}
        {getRootNodes().map(node => (
          <TreeNode
            {...props}
            key={node._id}
            node={node}
            getChildNodes={getChildNodes}
            openModal={props.openModal}
          />
        ))}
      </div>
    </>
  );  
};

const styles = {
  spinnerDiv: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    background: 'rgba(255, 255, 255, 0.5)',
    zIndex: 100,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
}

export default Tree;
